<div fxLayout="row wrap"
  fxLayout.lt-lg="column">

  <div *ngFor="let key of objectKeys(statistics)"
    fxFlex.gt-md="50"
    class="item">
    <div>{{ ('PROFILE.STATISTICS.'+key) | translate }}:</div>
    <div>{{ statistics[key] }}</div>
  </div>
</div>